import React, { useContext, useEffect, useState } from 'react';

import TopContext from './TopContext';
import defaultLabels from '../default-labels.json';
import { fetchWithRetry } from '@flos/react-ui';
import { log, logError } from '../lib/logger';

const ResourceBundle = React.createContext<{ [key: string]: string }>({});

const ResourceContext = ({ children }: { children: React.ReactNode }) => {
    const [resourceBundle, setResourceBundle] = useState<{ [key: string]: string }>({});
    const {
        endpointConfig: { resourceBundle: host },
    } = useContext(TopContext);

    useEffect(() => {
        (async () => {
            try {
                const response = await fetchWithRetry(`${host}/contact-us-load-visualization/`, {
                    method: 'GET',
                });

                const body = await response.json();

                log('Got the resource bundle', body);

                setResourceBundle(body);
            } catch (e) {
                logError(`Error fetching resource bundle : ${e}`);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ResourceBundle.Provider
            value={{
                ...defaultLabels,
                ...resourceBundle,
            }}
        >
            {children}
        </ResourceBundle.Provider>
    );
};

export const useResourceBundle = () => useContext<{ [key: string]: string }>(ResourceBundle);
export default ResourceContext;
